module.exports = __webpack_public_path__ + "img/no-estimate.ed830d8f.svg";